import {Box, Typography} from "@mui/material";
import {DataGrid, GridColDef, GridToolbar} from '@mui/x-data-grid';
import React, {useEffect, useState} from "react";
import {SignInActivity} from "../domain/SignInActivity";
import Grid from "@mui/material/Grid2";
import {useTranslation} from "react-i18next";
import {format, differenceInDays} from 'date-fns';
import useSignInActivities from "../hooks/useSignInActivities";
import {DATE_TIME_CONSTANT_FORMAT} from "../util/Constants";

interface SignInListDisplayProps {
    accountGuid: string | undefined
}


export function SignInListDisplay({accountGuid} : SignInListDisplayProps) {
    const {t, i18n} = useTranslation();
    const {data, error, loading, fetchData} = useSignInActivities();
    const [rowData, setRowData] = useState<SignInActivity[]>([]);

    useEffect(() => {
        if (accountGuid != null) {
            fetchData(accountGuid)
        }
    }, [accountGuid])

    useEffect(() => {
        if (data) {
            setRowData(data);
        }
    }, [data]);

    const columns: GridColDef<SignInActivity>[] = [
        {
            field: 'id',
            headerName: t('domain.signInActivity.id'),
            width: 90,
        },
        {
            field: 'signInActivityType',
            headerName: t('domain.signInActivity.activity'),
            width: 200,
            valueGetter: (value:String) => {
                return t(`domain.signInActivity.activities.${value}`)}
        },
        {
            field: 'timestamp',
            headerName: t('domain.signInActivity.timestamp'),
            width: 230,
            type: 'dateTime',
            valueGetter: (value) => value && new Date(value),
            valueFormatter: (value?: Date) => {
                if (value == null) {
                    return '-';
                }

                 return format(value, DATE_TIME_CONSTANT_FORMAT);
            },
        },
        {
            field: 'daysAgo',
            headerName: t('domain.signInActivity.daysAgo'),
            width: 90,
            type: 'number',
            valueGetter: (value, row) => {
                if (row.timestamp === null) {
                    return '0';
                } else {
                    return differenceInDays(new Date(), row.timestamp);
                }
            }
        },
        {
            field: 'ipAddress',
            headerName: t('domain.signInActivity.ipAddress'),
            width: 160
        },
        {
            field: 'applicationId',
            headerName: t('domain.signInActivity.appId'),
            width: 300
        },
        {
            field: 'applicationName',
            headerName: t('domain.signInActivity.appName'),
            width: 300
        },


    ];


    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                <Box sx={{color:'primary.contrastText', bgcolor: 'primary.main', p: 1}}>
                    <Typography variant={"h6"}>{t('views.lookupCustomerAccountView.signActivityPanel.title')}</Typography>
                </Box>
            </Grid>
            <Grid size={12}>
                <DataGrid
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'timestamp', sort: 'desc' }],
                        },
                    }}

                    slotProps={{
                        loadingOverlay: {
                            variant: 'linear-progress',
                            noRowsVariant: 'skeleton',
                        },
                    }}
                    slots={{toolbar: GridToolbar}}
                    rowHeight={40}
                    rows={rowData}
                    columns={columns}
                    loading={loading}
                />
            </Grid>
        </Grid>
    );
}